import { store } from '..';

enum ViewMode {
  // power in kW
  AVERAGE_POWER = 'averagePower',
  // CO₂ emissions in kg/h
  CO2E = 'co2e',
}

// keys should be the same as ViewMode
enum ViewModeUnit {
  AVERAGE_POWER = 'kW',
  CO2E = 'kg/h',
}

const toggleViewMode = () => {
  store.viewMode =
    store.viewMode === ViewMode.AVERAGE_POWER
      ? ViewMode.CO2E
      : ViewMode.AVERAGE_POWER;
};

export { ViewMode, ViewModeUnit, toggleViewMode };
